module.exports = __webpack_public_path__ + "static/media/Extra.969a26cc.png";